module.exports = __webpack_public_path__ + "img/Tool-moving-filled.7d22fbf7.svg";